'use client';

import * as React from 'react';
export const GridConfigurationContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  GridConfigurationContext.displayName = 'GridConfigurationContext';
}